import { render } from "./InstanceRedemptionBox.vue?vue&type=template&id=8c990cdc"
import script from "./InstanceRedemptionBox.vue?vue&type=script&lang=js"
export * from "./InstanceRedemptionBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__